import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useCacheMutation from "~hooks/useCacheMutation";
import { getFunilObras, getObrasAtivas, salvarFunilObras } from "~services/FunnelService";

export const useGetFunilObra = (enabled) => {
  const queryClient = useQueryClient();
  const [isSuccessHandled, setIsSuccessHandled] = useState(false);

  const data = useQuery(
    ["funil-obras"],
    () => getFunilObras(), 
    {
      onSuccess: () => {
        if (!isSuccessHandled) {
          queryClient.removeQueries(["funil-obras"], { exact: true });
          
          setIsSuccessHandled(true);
        }
      },
      staleTime: 5000,
      cacheTime: 0,
      refetchOnWindowFocus: false, 
      refetchOnReconnect: false, 
      enabled
    }
  );

  useEffect(() => {
    if (enabled && !isSuccessHandled) {
      data.refetch();
    }
  }, [enabled, isSuccessHandled, data]);

  return data;
};

export const useGetObrasAtivas = (enabled, formatada = false) => {
  const obrasAtivas = useQuery(["obras-ativas", formatada], () => getObrasAtivas(formatada), {
    enabled: enabled,
  });
  return obrasAtivas;
};

export const useSalvarFunilObras = (funisObras, onSuccessCloseModal, onErrorCloseModal) => {
  const { mutateCached } = useCacheMutation(
    salvarFunilObras,
    "Salvar Funil de Obras",
    onSuccessCloseModal,
    onErrorCloseModal,
    "Verifique em funil de obras"
  );

  const handleSave = () => {
    mutateCached(funisObras);
  };

  return handleSave;
};